// extracted by mini-css-extract-plugin
export var fadeIn = "ModalWithChildren-module--fadeIn--9e2ff";
export var modalBackground = "ModalWithChildren-module--modalBackground--e3481";
export var modalCloseButton = "ModalWithChildren-module--modalCloseButton--c8729";
export var modalDialog = "ModalWithChildren-module--modalDialog--03da7";